"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React, { forwardRef } from "react";
import * as styles from "./Stack-css";
import { assignInlineVars } from "@vanilla-extract/dynamic";
export const Stack = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      gap,
      padding,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
      element: Element = "div",
      children,
      className,
      align,
      justify,
      direction = "vertical",
      zIndex,
      wrap,
      relative,
      style
    } = _b, rest = __objRest(_b, [
      "gap",
      "padding",
      "paddingTop",
      "paddingRight",
      "paddingBottom",
      "paddingLeft",
      "element",
      "children",
      "className",
      "align",
      "justify",
      "direction",
      "zIndex",
      "wrap",
      "relative",
      "style"
    ]);
    return /* @__PURE__ */ React.createElement(
      Element,
      __spreadValues({
        className: [
          styles.stack(__spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, getSpacingVariants({ padding })), getSpacingVariants({ paddingTop })), getSpacingVariants({ paddingRight })), getSpacingVariants({ paddingBottom })), getSpacingVariants({ paddingLeft })), getSpacingVariants({ gap })), {
            align,
            justify,
            direction,
            wrap,
            relative
          })),
          className
        ].join(" "),
        ref,
        style: __spreadValues(__spreadValues({}, zIndex ? assignInlineVars({ [styles.stackZIndex]: `${zIndex}` }) : {}), style)
      }, rest),
      children
    );
  }
);
function getSpacingVariants(value) {
  const [property, spacing] = Object.entries(value)[0];
  if (!spacing)
    return {};
  if (typeof spacing === "string") {
    return { [property]: spacing };
  }
  const variants = {};
  for (const [key, value2] of Object.entries(spacing)) {
    if (key === "default")
      continue;
    variants[`${property}_${key}`] = value2;
  }
  if (spacing.default) {
    variants[property] = spacing.default;
  }
  return variants;
}
